
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-4'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>제품 관리 - 3단계 : 제품 분류 관리</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminProductDivisionTwoLevelManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>* "제품 관리"는 제품 등록 시 서로 연결되어있는 메뉴입니다.</p>
            <p>* 3단계 : 제품 분류는 의자에서 다이닝 체어, 바 체어, 스툴 등의 소카테고리 분류를 뜻하며, 없을 경우 생략 가능 합니다. </p>
            <br>
            <p>1. 리스트 정렬은 ID와 상관없이 순서대로이며, 상단이 우선 순위가 높습니다.</p>
            <p>2. 왼쪽 3선 작대기를 클릭&드래그하여 위/아래로 이동할 수 있습니다.</p>
            <p>3. 삭제는 안되며 수정 버튼을 통해 사용여부를 미사용으로 활용하면 됩니다.</p>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_product_division_two_level,
  update_product_division_two_level_order
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminProductDivisionTwoLevelManagement',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminProductDivisionTwoLevelManagementAdd?product_division_two_level_ID=${this.tabulator.getSelectedData()[0].product_division_two_level_ID}`
      }
    }
  },
  mounted () {
    get_product_division_two_level().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        columns: [
          {rowHandle: true, formatter: 'handle', headerSort: false, frozen: true, width: 30, minWidth: 30},
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'ID', field: 'product_division_two_level_ID', headerSort: false},
          {title: '제품분류 1단계명', field: 'product_division_one_level_kor_name', headerSort: false},
          {title: '한글명', field: 'product_division_two_level_kor_name', headerSort: false},
          {title: '영문명', field: 'product_division_two_level_eng_name', headerSort: false},
          {title: '사용 여부', field: 'product_division_two_level_activate', headerSort: false},
          {title: '등록 일자', field: 'product_division_two_level_registe', headerSort: false},
          {title: '수정 일자', field: 'product_division_two_level_modified', headerSort: false}
        ]
      })
      this.tabulator.on('rowMoved', function (row) {
        let temp_product_division_two_level_order_array = []
        let product_division_two_level_order = 0
        const table = row.getTable()
        table.getRows().forEach(element => {
          temp_product_division_two_level_order_array.push({
            product_division_two_level_order: product_division_two_level_order,
            product_division_two_level_ID: element._row.data.product_division_two_level_ID
          })
          product_division_two_level_order++
        })
        update_product_division_two_level_order(temp_product_division_two_level_order_array).then(result => {
          if (result === undefined) {
            alert('순서가 변경되지 않았습니다. 관리자한테 확인해주세요.')
          }
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ProductManagement/AdminProductDivisionTwoLevelManagement.vue